export default "__VITE_ASSET__2a2052cf__"